/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaQualityDefinitionResponse model module.
 * @module model/AqaQualityDefinitionResponse
 * @version v0
 */
export default class AqaQualityDefinitionResponse {
  /**
   * Constructs a new <code>AqaQualityDefinitionResponse</code>.
   * @alias module:model/AqaQualityDefinitionResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaQualityDefinitionResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaQualityDefinitionResponse} obj Optional instance to populate.
   * @return {module:model/AqaQualityDefinitionResponse} The populated <code>AqaQualityDefinitionResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaQualityDefinitionResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('timestamp'))
        obj.timestamp = ApiClient.convertToType(data['timestamp'], 'Number');
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaQualityDefinitionResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaQualityDefinitionResponse.prototype.message = undefined;

/**
 * @member {String} id
 */
AqaQualityDefinitionResponse.prototype.id = undefined;

/**
 * @member {String} name
 */
AqaQualityDefinitionResponse.prototype.name = undefined;

/**
 * @member {Number} timestamp
 */
AqaQualityDefinitionResponse.prototype.timestamp = undefined;

/**
 * @member {Boolean} successful
 */
AqaQualityDefinitionResponse.prototype.successful = undefined;

